<div class="row mx-0">
  <div class="col-md-6 head-top">
    <div class="send-money ">

      <div class="sm-18 font-weight-bold color-blue pl-2 pb-3">You are sending money to:</div>
      <div class="card border-0" style="border-radius:5px">
        <div class="card-body bg-alice radius-5">
          <div class="row">
            <div class="col-md-8 col-8">
              <h5 *ngIf="auth.user.country_id==233" class=" sm-16">{{sendMoneyService.receiver.first_name}}
                {{sendMoneyService.receiver.last_name}} </h5>
              <h5 *ngIf="auth.user.country_id==39" class=" sm-16">{{sendMoneyService.receiver.payee_name}} </h5>
            </div>
            <div class="col-md-4 col-4"><img src="assets/images/check.png">
            </div>
          </div>
          <small *ngIf="auth.user.country_id==233" class="custom-text-font text-secondary ">
            {{sendMoneyService.receiver.bank_name}} account ending with
            {{sendMoneyService.receiver.account_number?.substr(sendMoneyService.receiver.account_number.length - 4)}}
          </small>
          <small *ngIf="auth.user.country_id==39" class="custom-text-font text-secondary ">
            {{sendMoneyService.receiver.payee_bank_name}} account ending with
            {{sendMoneyService.receiver.payee_account_number.substr(sendMoneyService.receiver.payee_account_number.length
            - 4)}}</small>
        </div>
      </div>
      <div class="card mt-2 border-0" style="border-radius:5px">
        <div class="card-body ">
          <div class="row">
            <div class="col-md-12">
              <h6 class="sm-16 gilroy-med color-royalblue mb-0">{{sendMoneyService.purpose.remittance_purpose}}</h6>
            </div>
          </div>

        </div>
      </div>



      <div class="pt-3">
        <form>
          <div class="div-block-13 bg-white w-100">
            <input type="number" style="background:none!important; border:none;"
              class="text-field w-input m-0 p-3 border-0" def="10" autofocus="true" maxlength="256" name="sending_amt"
              [(ngModel)]="sendMoneyService.transactionDetails.sending_amt" required readonly>
            <div class="w-dropdown bg-alice radiusr-5">
              <div class="dropdown-toggle-2 w-dropdown-toggle p-3">
                <div id="from-currency" class="div-block-11 mr-0">
                  <div class="selected-currency-code mr-1">{{auth.user.currency.toUpperCase()}}</div>
                  <img [src]="'assets/images/'+auth.user.currency.toLowerCase()+'.png'" loading="lazy" width="25"
                    alt="n2xpress - Money Transfer - Canadian Dollar" class="image-7 m-0 "
                    [ngClass]="{'flag-send-money' : auth.user.currency=='usd'}">
                </div>
              </div>
            </div>
          </div>
          <div class="rate-panel">
            <div class="div-block-15" [ngClass]="{'more-height' : sendMoneyService.transactionDetails.coupon_id}"
              *ngIf="auth.user.country_id==233"></div>
            <div class="div-block-15-ca" [ngClass]="{'more-height-ca' : sendMoneyService.transactionDetails.coupon_id}"
              *ngIf="auth.user.country_id==39"></div>
            <div class="div-block-16">
              <div class="div-block-18 py-2">
                <span class="bg-alice rounded-circle symbol color-blue">x</span>
                <div class="rate-figure">
                  <div id="currency-rate" class="text-block-12 sm-12">
                    {{sendMoneyService.transactionDetails.exchange_rate}}</div>
                </div>
                <div class="rate-currency">
                  <div id="exchange-currency" class="rate-currency-text sm-12">
                    {{sendMoneyService.receiver.currency.toUpperCase()}}</div>

                </div>
                <div class="rate-explainer">
                  <div class="explainer-text sm-12">Your exchange rate</div>
                </div>
              </div>

              <div class="div-block-13-copy bg-white w-100">
                <input type="number" style="background:none!important; border:none;"
                  class="text-field w-input m-0 p-3 border-0" name="send_amt" maxlength="256" readonly
                  [(ngModel)]="sendMoneyService.transactionDetails.send_amt">
                <div class="w-dropdown bg-alice radiusr-5">
                  <div class="cxy-dropdown-toggle w-dropdown-toggle p-3">
                    <div id="to-currency" class="div-block-11 mr-0">
                      <div class="text-block-10">{{sendMoneyService.receiver.currency.toUpperCase()}}</div>
                      <img [src]="'assets/images/'+sendMoneyService.receiver.currency+'.png'" loading="lazy" width="25"
                        alt="n2xpress - Money Transfer - Indian Rupee" class="image-7 m-0">
                    </div>

                  </div>
                </div>
              </div>
              <div class="div-block-17 py-2">
                <span class="bg-alice rounded-circle symbol color-blue">+</span>
                <div>
                  <div class="fee-figure sm-12">{{ sendMoneyService.transactionDetails.fee_amount }}</div>
                </div>
                <div class="rate-currency">
                  <div class="rate-currency-text sm-12">{{ auth.user.currency.toUpperCase() }}</div>
                </div>
                <div class="fee-explainer-text">
                  <div class="explainer-text">Payment processing fee</div>
                </div>
              </div>
              <div class="div-block-17 py-2" *ngIf="auth.user.country_id == 233">
                <span class="bg-alice rounded-circle symbol color-blue">+</span>
                <div>
                  <div class="fee-figure sm-12">{{ sendMoneyService.transactionDetails.gateway_fee }}</div>
                </div>
                <div class="rate-currency">
                  <div class="rate-currency-text sm-12">{{ auth.user.currency.toUpperCase() }}</div>
                </div>
                <div class="fee-explainer-text">
                  <div class="explainer-text">Gateway fee</div>
                </div>
              </div>
              <div class="div-block-17 py-2" *ngIf="auth.user.country_id == 39">
                <span class="bg-alice rounded-circle symbol color-blue">+</span>
                <div>
                  <div class="fee-figure sm-12">{{ sendMoneyService.selectedCAPaymentMethod.gateway_fee }}</div>
                </div>
                <div class="rate-currency">
                  <div class="rate-currency-text sm-12">{{ sendMoneyService.selectedCAPaymentMethod.gateway_fee_type ?
                    '%' : auth.user.currency.toUpperCase() }}</div>
                </div>
                <div class="fee-explainer-text">
                  <div class="explainer-text">Payment fee</div>
                </div>
              </div>
              <!-- <div class="mt-3">
                <div class="card-header p-0 border-0" style="background: none;" role="tab" id="headingOne1">
                  <a data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne2"
                  aria-expanded="true" aria-controls="collapseOne1" (click)="changeHeight()">
                  <h5 class="mb-0">
                    <div class="row">
                      <div class="col-8 sm-14 color-blue mobile16">
                        Apply Promocode
                      </div>
                      <div class="col-4">
                        <i class="fas fa-angle-down rotate-icon float-left"></i>
                      </div>
                    </div>
                  </h5>
                  </a>
                </div>
              </div> -->
              <!-- <div id="collapseOne2" class="collapse p-0" role="tabpanel" aria-labelledby="headingOne1"
            data-parent="#accordionEx"> -->
              <!-- <div class="card-body p-0"> -->
              <!-- <div class="row"> -->
              <div class="col-md-12" *ngIf="sendMoneyService.transactionDetails.coupon_id">
                <input type="text" class="form-control  promocode-form p-0"
                  [value]="sendMoneyService.transactionDetails.coupon_code" readonly>
              </div>
              <!-- </div> -->
              <!-- </div> -->
              <!-- </div> -->
              <div class="div-block-18-copy">
                <span class="bg-alice rounded-circle symbol color-blue">=</span>
                <div class="rate-figure">
                  <div id="currency-rate" class="text-block-12 sm-12">{{ sendMoneyService.transactionDetails.amount }}
                  </div>
                </div>
                <div class="rate-currency">
                  <div id="exchange-currency" class="rate-currency-text sm-12">{{auth.user.currency.toUpperCase()}}
                  </div>

                </div>
                <div class="rate-explainer">
                  <div class="secondary-text sm-10">Total you will be charged</div>
                </div>
              </div>
              <!-- *ngIf="sendMoneyService.transactionDetails.celoData.payment_id == 6" -->
              <div class="div-block-18-copy"
                *ngIf="sendMoneyService?.transactionDetails.celoData.paymentSelectedoption.payment_gateways_id == 6">
                <span class="bg-alice rounded-circle symbol color-blue">=</span>
                <div class="rate-figure">
                  <div id="currency-rate" class="text-block-12 sm-12">{{
                    sendMoneyService.transactionDetails.celoData.response.celo_value_plus_fee }}</div>
                </div>
                <div class="rate-explainer">
                  <div class="secondary-text sm-10">cUSD</div>
                </div>
              </div>
              <div>
                <!--  {{sendMoneyService.fundingSource.institution_name}} -->
              </div>

            </div>
          </div>
          <div class="d-flex justify-content-between step3-btn address_field">
            <button (click)="goBack()" type="button" class="btn transparent-btn primary-text back-btn">Back</button>
            <button *ngIf="auth.user.country_id==233" (click)="displayDebitAuthorization=true" type="button"
              class="btn btn-primary w-100">Confirm and pay now</button>
            <button *ngIf="auth.user.country_id==39" (click)="onConfirmSendMoney()" type="button"
              class="btn btn-primary w-100">Confirm and pay now</button>

          </div>
        </form>
        <p-dialog header="Debit Authorization" [(visible)]="displayDebitAuthorization" [baseZIndex]="10000"
          styleClass="mydialog">
          <div [innerHTML]="debitAuthorization"></div>
          <ng-template pTemplate="footer">
            <p-button icon="pi pi-times" (click)="displayDebitAuthorization=false" label="Disagree"
              styleClass="p-button-text"></p-button>
            <p-button icon="pi pi-check" (click)="onConfirmSendMoney()" label="Confirm and Pay"
              styleClass="p-button-text"></p-button>
          </ng-template>
        </p-dialog>
      </div>


    </div>
  </div>
  <div *ngIf="limit_error">
      <div class="alert alert-danger alert-dismissible">
        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
        <p>{{limit_error}}</p>
      </div>
  </div>
  
</div>